import { Box, Grid, Paper } from "@mui/material";
import React, { ReactNode } from "react";

interface CustomPaperProps {
  children: ReactNode;
}

const PaperCard = ({ children }: CustomPaperProps) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexWrap: "wrap",
        border: "1px solid #E6E6E6",
        borderRadius: "8px",
        padding: "24px 24px 0px 24px ",
        marginTop: 2,
        height: "100%",
        background: "#fff",
      }}
    >
      <Grid container>
        <Grid item xs={12} sm={12} md={12} lg={12}>
          <Paper elevation={0}>{children}</Paper>
        </Grid>
      </Grid>
    </Box>
  );
};

export default PaperCard;
